import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {JiraIssueDTO} from '../models/jira/JiraIssueResponseDTO';

@Injectable({
  providedIn: 'root'
})
export class JiraService {
  private url = environment.baseWeUrl + '/jira';

  constructor(private httpClient: HttpClient) { }

  getIssueByKey(key: string): Observable<JiraIssueDTO> {
    const relativePath = `/request?key=${key}`;
    return this.httpClient.get<JiraIssueDTO>(this.url + relativePath);
  }
}
